import { config } from '@services/config';
import { BrokerageOfferingsSearchRequestQuery, BrokerageOfferingsSearchResponse } from '@lio/api-types';
import { offeringKeys } from '@services/brokerage/offering/offering.keys';
import { useQuery } from '@tanstack/react-query';
import { useClient } from '@utils/api-client';
import { convertToISOStringIfDate } from '@utils/date';

export const useSearchBrokerageOfferings = (
  params: BrokerageOfferingsSearchRequestQuery & {
    enabled?: boolean;
    brokerageId?: string;
  },
) => {
  const { enabled, brokerageId, offeringId, jurisdictionId, effectiveDate } = params;
  const queryParams = new URLSearchParams();
  if (offeringId) {
    queryParams.append('offeringId', offeringId);
  }
  if (effectiveDate) {
    queryParams.append('effectiveDate', convertToISOStringIfDate(effectiveDate));
  }
  if (jurisdictionId) {
    queryParams.append('jurisdictionId', jurisdictionId);
  }

  queryParams.append('pageLimit', '200');
  const client = useClient();
  return useQuery<BrokerageOfferingsSearchResponse, Error>({
    queryKey: offeringKeys.brokerageOfferingsSearchWithParams(brokerageId, {
      offeringId,
      jurisdictionId,
      effectiveDate,
    }),
    queryFn: async () =>
      client
        .get(`brokerage/${brokerageId}/brokerage-offering?${queryParams.toString()}`)
        .json<BrokerageOfferingsSearchResponse>(),
    enabled: !!enabled && !!brokerageId,
    ...config,
  });
};
